import AppAnalytics from '@adc/analytics'

const { init, trackDataLayerLoaded } = AppAnalytics

const analytics = {}

const trackPageLoad = (user = {}, additionalData = {}) => {
  init(window.CONFIGS).then(() => {
    trackDataLayerLoaded(user, additionalData)
  })
}

analytics.trackPageLoad = trackPageLoad

export default analytics
